import client from "lib/api/client"

// 動作確認用
export const getRankings = () => {
  return client.get("/ranking_temp_masters")
}
